import { NgModule } from '@angular/core';
import { CommonModule, NgClass } from '@angular/common';
import { A11yModule } from '@angular/cdk/a11y';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatOptionModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatAccordion, MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatStep, MatStepper } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { NgxMaterialIntlTelInputComponent } from 'ngx-material-intl-tel-input';
import {CdkAccordionModule} from '@angular/cdk/accordion';
import {MatTabsModule} from '@angular/material/tabs';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import {MatCheckboxModule} from '@angular/material/checkbox';
import { DesignSystemModule } from '../design-system/design-system.module';
@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    MatAccordion,
    MatExpansionPanel,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle,
    MatFormFieldModule,
    MatInputModule,
    NgClass,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    MatIconModule,
    RouterLink,
    RouterLinkActive,
    MatOptionModule,
    MatSelectModule,
    MatStep,
    MatStepper,
    MatDatepickerModule,
    MatAutocompleteModule,
    MatPaginatorModule,
    MatTableModule,
    MatProgressSpinnerModule,
    NgxMaterialIntlTelInputComponent,
    MatFormFieldModule,
    MatInputModule,
    MatDialogModule,
    NgxExtendedPdfViewerModule,
    A11yModule,
   CdkAccordionModule,
   MatTabsModule,
   MatMenuModule,
   MatButtonModule,
   MatCheckboxModule,
   DesignSystemModule
   
  ], exports: [
    CommonModule,
    MatAccordion,
    MatExpansionPanel,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle,
    MatFormFieldModule,
    MatInputModule,
    NgClass,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    MatIconModule,
    RouterLink,
    RouterLinkActive,
    MatOptionModule,
    MatSelectModule,
    MatStep,
    MatStepper,
    MatDatepickerModule,
    MatAutocompleteModule,
    MatPaginatorModule,
    MatTableModule,
    MatProgressSpinnerModule,
    NgxMaterialIntlTelInputComponent,
    MatFormFieldModule,
    MatInputModule,
    MatDialogModule,
    NgxExtendedPdfViewerModule,
    A11yModule,
    CdkAccordionModule,
    MatTabsModule,
    MatMenuModule,
    MatButtonModule,
    MatCheckboxModule,
    DesignSystemModule
  ]
})
export class SharedModule { }
